//Navigation-bar
export const navigation = [

    {
        title: "About Us",
        Items: [
            {
                title: "About SteelX",
                path: "/about",
            },
            {
                title: "Mission,Vision& Values",
                path: "/about/vision-mission-values",
            },

        ]


    },
    {
        title: "Products & Services",
        Items: [

            {
                title: "Factory Model",
                path: "/productservices/factory-model",
            },
            {
                title: "Accessories",
                path: "/productservices/accessories",
            },
        ]


    },
    {
        title: "Projects",
        Items: [
       

            {
                title: "Projects",
                path: "/projects",
            },

        ]


    },
    {
        title: "Join Us",
        Items: [

            {
                title: "Careers At SteelX",
                path: "/join/careers-at-steelx",
            },


        ]


    },
    {
        title: "Contact us",
        Items: [

            {
                title: "Manufacturing Location",
                path: "/contact/manufacturing-location",
            },
            {
                title: "Enquire Now",
                path: "/contact/enquire-now",
            },



        ]


    },
    {
        title: "Brochure",
        Items: [
            {
                title: "Download Brochure",
                path: "https://firebasestorage.googleapis.com/v0/b/boss-storage.appspot.com/o/Steelx%20brochure.pdf?alt=media&token=c0d92c0f-3436-4569-9b74-58eefb0e8a95",
            },


        ]


    },



]

// Home Data
//Hero Section
export const Home_Hero_Section = {
    top_heading: "",
    middle_heading: "",
    lower_heading: "",
    description: "",
    bg_video_path1: '/assests/Bg new video.mp4',
    card_video_url1: '/assests/smallvid.mp4',

}
//Section2 - Crafted for Excellence, Forged for Longevity
export const Home_Section2 = {
    heading: "Crafted for Excellence, Forged for Longevity",
    description: "SteelX Building Systems stands as the optimal selection for businesses and institutions in search of pre-engineered and structural steel constructions. Our services prioritize customers, blending top-notch quality, rapid execution, and unwavering safety standards.",


}
//Section3 - Our Proficiency
export const Home_Section3 = {
    haeding: "Our Proficiency Across Diverse Applications",

}

//Section4 - Why Us
export const Home_Section4 = {
    haeding: "Why Steelx Infrastructure?",
    Items: [
        {
            description: "Ranked Among the Pioneers in PEB Manufacturing Worldwide",
        },
        {
            description: "Extensive Global Project Presence",
        },
        {
            description: "International Engineering Excellence Infused with Cutting-Edge Solutions",
        },
        {
            description: "Exemplary Safety Protocols and Environmentally Responsible Building Solutions",
        },
        {
            description: "Comprehensive Solutions for Construction and Engineering",
        },

    ]

}

//Section5 - Machineries
export const Home_Section5 = {
    haeding: "Machineries",
    Items: [
        {
            img: "/assests/Svgs/mac1.svg",

        },
        {
            img: "/assests/Svgs/mac2.svg",

        },
        {
            img: "/assests/Svgs/mac3.svg",

        },

        {

            img: "/assests/Svgs/mac4.svg",
        },
        {
            img: "/assests/Svgs/mac5.svg",
        },
        {
            img: "/assests/Svgs/mac6.svg",
        },
    ]
}

// Footer 
export const footerNavs = [
    {
        label: "Resources",
        items: [
            {
                href: '/contact/enquire-now',
                name: 'Contact'
            },
            {
                href: '/productservices/pre-engineered-steel-buildings',
                name: 'PEB'
            },
            {
                href: '/join/careers-at-steelx',
                name: 'Career'
            },
            {
                href: 'https://firebasestorage.googleapis.com/v0/b/boss-storage.appspot.com/o/Steelx%20brochure.pdf?alt=media&token=c0d92c0f-3436-4569-9b74-58eefb0e8a95',
                name: 'Brochure'
            },
        ],
    },
    {
        label: "About",
        items: [
            {
                href: '/about',
                name: 'About Steelx'
            },
            {
                href: '/about/vision-mission-values',
                name: 'Vision and Mission'
            },
            {
                href: '/about/vision-mission-values',
                name: 'Our Value'
            },
            {
                href: 'https://cloudburst-sati.web.app/',
                name: 'Developers'
            },

        ]
    },
    {
        label: "Explore",
        items: [
            {
                href: '/productservices/pre-engineered-steel-buildings',
                name: '3D Model'
            },
            {
                href: '/productservices/accessories',
                name: 'Accessories'
            },
            {
                href: '/projects',
                name: 'Latest Projects'
            },
            {
                href: '/productservices/accessories',
                name: 'Machineries'
            },
        ]
    },
    {
        label: "Company",
        items: [
            {
                href: '/about',
                name: 'Partners'
            },
            {
                href: '/contact/manufacturing-location',
                name: 'Manufacturing Locations'
            },
            {
                href: '/contact/enquire-now',
                name: 'Enquiry Now'
            },
        ],
    }
]


//About
export const About_data = {
    heading: "About Us",
    bg_img: "/assests/Svgs/aboutus.svg"
}

// About Section 1
export const About_Section1 = {
    heading: " SteelX: A Century of Customer Excellence",
    description1: "Throughout its enduring history, SteelX, a subsidiary of Alghanim Industries based in Kuwait, has remained steadfast in setting and advancing the benchmarks for pre-engineered and structural steel buildings. With a heritage spanning over a century and as part of Alghanim Industries, one of the largest privately owned companies in the Middle East, we bring unparalleled expertise to the global construction landscape.",
    description2: "Join us in shaping the next chapter of excellence at SteelX, where a century-long legacy meets a future dedicated to exceeding customer expectations and pushing the boundaries of quality in the steel construction industry.",

}
// About Section 2
export const About_Section2 = {
    heading: "  Unmatched Scale: Global Presence, Robust Capacity at SteelX",
    description: `  SteelX operates from seven cutting-edge manufacturing facilities strategically located in Kuwait, Saudi Arabia, Ras Al Khaimah, Vietnam, and India. With a combined installed capacity exceeding 515,000 MT annually, we are supported by a diverse team of 2000+ skilled professionals.

    Our reach extends globally through a network of 2 plus sales offices and 300 certified builders across the Middle East, the Indian Sub-Continent, Africa, and South East Asia. This extensive network positions us as a leader in the steel construction industry.
    
    SteelX products find applications in diverse market segments such as heavy industry, infrastructure, high-rise buildings, warehouses, factories, oil & gas, commercial, and leisure structures. Our impact spans across all major industry segments, solidifying our position as a global force in steel manufacturing.`,

}

// About SEction 3
export const About_Section3 = {
    heading: "Excellence Centralized: Our Center of Engineering Excellence (CEE)",
    description: `Excellence Centralized: Our Center of Engineering Excellence (CEE), based in Hyderabad, India, serves as the epicenter for optimizing four crucial pillars – people, systems, performance, and products. Powered by the latest technology and best-in-class practices, our CEE is dedicated to driving research and development, design, and talent training with unwavering focus.`,

}


//Vision and mission
export const Vision_data = {
    heading: "Vision",
    description: "Empowering Futures Worldwide: Our vision is to be acknowledged as the global frontrunner in the innovative design, manufacturing, supply, and erection of pre-engineered steel buildings (PEB) and structures."
}

export const Mission_data = {
    heading: "Mission",
    description: "  At SteelX, our mission is to consistently deliver top-tier products to our customers, coupled with personalized services and an unwavering commitment to excellence. We strive to redefine industry standards and ensure enduring satisfaction in every endeavor.",
    img_url: "/assests/Svgs/vision1.svg",
}


//Our Values
export const OurValues = [
    {
        heading: "Straightforward Communication",
        description: " We foster candid discussions, valuing open debates where the best ideas emerge triumphant.",
    },
    {
        heading: "Customer-Centric Approach",
        description: "At SteelX, customers are at the heart of our focus and initiatives. We strive to exceed expectations through dedicated service and innovative solutions."
    },
    {
        heading: "Collaborative Team Spirit",
        description: "We embrace teamwork, actively sharing information and ideas, collectively working to elevate the capabilities of those around us",
    },
    {
        heading: "Diversity & Inclusivity",
        description: " Our workforce's diversity is an invaluable asset. We treat everyone with dignity and respect, irrespective of status, gender, education, ethnicity, or religion."
    },
    {
        heading: "Empowerment Culture",
        description: "We believe in empowering individuals to make decisions with a proactive mindset, fostering a culture of action."
    },
    {
        heading: "Valuing Employees",
        description: "At SteelX, our employees are our greatest asset. We go the extra mile to ensure continuous training, development, and motivation."

    },
    {
        heading: "Merit-Based Recognition",
        description: "We operate on a meritocracy principle, where rewards and career advancements are solely based on performance and capabilities."
    }
]

//Accessories
export const Applications=[
    {
        heading:"Skylights & Wall Lights",
        description:"Made of translucent GRP to match Kirby rib and wall panels, with an estimated light transmitting capacity of 60 %.",
    },
    {
        heading:"Roof Jacks",
        description:"These are enclosures for pipes or stacks projecting from the roof. They allow for safe working on the roof.",
    },
    {
        heading:"Aircraft Hangar Doors",
        description:"Steelx provides solutions for special applications such as aircraft hangars, customized hangar doors and framing, customized support systems for special equipment and maintenance cranes.",
    },
    {
        heading:"Sliding Doors",
        description:"Sliding doors are used in hangars, warehouses, etc., where a larger opening into the building is required. They are not hinged but rather rollers are provided on top of the doors and this roller is placed on brackets allowing a sliding movement.",
    },
    {
        heading:"Ridge Ventilators",
        description:"This is a gravity-type ventilator which is provided with a bird screen and mechanical controlled damper. Allows natural ventilation of the building.",
    },
    {
        heading:"Turbovents",
        description:"whirlwind low silhoutte extract ventilator with spun aluminium nonreturn shutter and one-piece base and throat. Mounted on GRP roof curb moulded to suit steelX Roof panels.",
    },
]


